<template>
  <div class="box box--challenge">
    <div class="box-img-wrapper">
      <!--<img class="challenge-thumbnail-img" :src="imageSource('desktop')">
      <img class="challenge-thumbnail-img-mobile" :src="imageSource('mobile')">-->
      <img class="idea-thumbnail-img" :src="'/placeholder-photo.png'">
      <img class="idea-thumbnail-img-mobile" :src="'/placeholder-photo.png'">
    </div>
    <div class="box-inner">
      <span class="box-tag"><i class="icon-flag2"></i><span>Challenge</span><span>{{ challenge.date | timeSince }}</span></span>
      <router-link :to="{name:'Challenge', params: {id: challenge.id}}" class="box-title">
        <span>{{ challenge.title }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChallengeBox',
  props: ['challenge'],
  methods: {
    imageSource (device) {
      if (this.challenge.image && this.challenge.image.url_challenge_thumbnail && this.challenge.image.url_challenge_thumbnail_mobile) {
        if (device === 'desktop') {
          return this.challenge.image.url_challenge_thumbnail
        } else if (device === 'mobile') {
          return this.challenge.image.url_challenge_thumbnail_mobile
        }
      }
      const source = ['/wp-content/themes/cg-ideaboard/images/home-active-1.png', '/wp-content/themes/cg-ideaboard/images/home-active-2.png', '/wp-content/themes/cg-ideaboard/images/home-active-3.png', '/wp-content/themes/cg-ideaboard/images/home-active-4.png']
      const pseudoRandom = this.challenge.id % 4
      return source[pseudoRandom]
    }
  }
}
</script>

<style scoped>

</style>
